import { useEffect, useState } from "react";

import { Grid, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GetUserCount, GetUserProfileInformation } from "../../Api/Signin/Dashboard.Api";
import { ReactComponent as ConvenienceFee } from "../../Assets/Images/ConvenienceFee.svg";
import { ReactComponent as Doctors } from "../../Assets/Images/Doctors_2.svg";
import { ReactComponent as Patient } from "../../Assets/Images/Patients.svg";
import { ReactComponent as TaxFee } from "../../Assets/Images/TaxConfiguration.svg";
import { CustomIconButton2 } from "../../Components/atoms/IconButton/IconButton";
import { Heading1 } from "../../Components/atoms/Typography/Heading/Heading";
import { ConvenienceFeeDrawer } from "../../Components/organisms/ConvenienceFeeDrawer/ConvenienceFeeDrawer";
import { SummarySection } from "../../Components/organisms/SummarySection/SummarySection";
import { TaxConfiguarationDrawer } from "../../Components/organisms/TaxConfiguarationDrawer/TaxConfiguarationDrawer";
import { useAuth } from "../../Store/AuthContext";
import useLoadingState from "../../Utils/Hooks/useLodingState";
import useOverlayState from "../../Utils/Hooks/useOverlayState";
import JwtDecoder from "../../Utils/JwtDecoder/JwtDecoder";
import "./OverView.style.css";

export default function OverView() {
  const { t } = useTranslation();

  const { state ,dispatch} = useAuth();

  const { OverlayState, openOverlay, closeOverlay } = useOverlayState();

  const { startLoading, stopLoading, LoadingState } = useLoadingState();

  const [userDetails, setUserDetails] = useState([]);

  const GetUsersPending = async () => {
    try {
      startLoading({ btnName: "getuserpending" });
      let response = await GetUserCount();
      if (response.type === 0) {
        setUserDetails({
          patientCount: response.data.patientCount,
          doctorCount: response.data.doctorCount,
        });
      }
      stopLoading();
    } catch (exception) {
      stopLoading();
    }
  };

  const loadUserProfileInformation = async () => {
    try {
      const result = await GetUserProfileInformation(JwtDecoder(localStorage.getItem("doctore")).email);
      if (result.type == 0) {
        dispatch({ type: "SET_USER_NAME", payload: result.data });
      }
    } catch (ex) {}
  };

  let cards = [
    {
      id: 1,
      image: Patient,
      heading: t("glossary:overview.patients"),
      amount: userDetails.patientCount,
    },
    {
      id: 2,
      image: Doctors,
      heading: t("glossary:overview.doctors"),
      amount: userDetails.doctorCount,
    },
  ];

  useEffect(() => {
    if (localStorage.getItem("doctore")) {
      GetUsersPending();
      loadUserProfileInformation();
    }
  }, [localStorage]);

  return (
    <>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignContent={"center"}
        alignItems={"center"}
      >
        <Grid item>
          <Heading1 text={t("glossary:overview.title")} />
        </Grid>
        <Grid item>
          <Stack direction={"row"}>
            <Grid item>
              <CustomIconButton2
                spacing={"10px"}
                icon={
                  <TaxFee
                    role="img"
                    type="image"
                    aria-label="Tax Fee Image"
                    fill="#ffffff"
                  />
                }
                onClick={() => {
                  openOverlay({ OverlayName: "tax" });
                }}
                variant={"lightBlue"}
                title={t("common:button.Caps-tax-configuaration")}
                color={"#FFFFFF"}
                width={"185px"}
                height={"48px"}
              />
            </Grid>
            <Grid item ml={"20px"}>
              <CustomIconButton2
                icon={
                  <ConvenienceFee
                    role="img"
                    type="image"
                    aria-label=" Convenience Fee image"
                    fill="#ffffff"
                  />
                }
                variant={"lightBlue"}
                title={t("common:button.Caps-convinience-fee")}
                color={"#FFFFFF"}
                spacing={"10px"}
                onClick={() => {
                  openOverlay({ OverlayName: "convinience" });
                }}
                width={"185px"}
                height={"48px"}
              />
            </Grid>
          </Stack>
        </Grid>
      </Stack>
      {/* <CustomIconButton2 icon={TaxFee} title={'Tax Configuration'} borderRadius={14}/> */}
      <Stack
        display={"flex"}
        flexDirection={"row"}
        position={"static"}
        width={"100%"}
      >
        <SummarySection cards={cards} isLoading={LoadingState.visible} />
      </Stack>

      {OverlayState.visible && OverlayState.OverlayName === "convinience" && (
        <ConvenienceFeeDrawer
          OpenDrawer={OverlayState.visible}
          close={closeOverlay}
        />
      )}
      {OverlayState.visible && OverlayState.OverlayName === "tax" && (
        <TaxConfiguarationDrawer
          OpenDrawer={OverlayState.visible}
          close={closeOverlay}
        />
      )}
    </>
  );
}
